/**
 * Split from ./hubspotCannabisEvents.ts so the mapping stays unit-testable:
 * HubspotTracker imports clientConfig, which needs the app runtime to resolve.
 */

import * as HubspotTracker from '../PixelTrackers/HubspotTracker';
import {
  buildFilterCannabisProperties,
  FILTER_CANNABIS_EVENT,
  FilterCannabisEventInput,
} from './hubspotCannabisEvents';

/** Sends the event for the current filter state. No-op outside DE. */
export const sendFilterCannabisEvent = (input: FilterCannabisEventInput, country?: string | null) => {
  if ((country || '').toLowerCase() !== 'de') {
    return;
  }

  const properties = buildFilterCannabisProperties(input);
  if (!properties) {
    return;
  }

  HubspotTracker.trackCustomEvent(FILTER_CANNABIS_EVENT, properties);
};
